// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./Radio";
export type { RadioProps, RadioOption } from "./Radio";
